<template>


		<div id="container">
			<div class="location">
				<ul>
					<li class="home">홈</li>
					<li>적하보험</li>
					<li>회원정보</li>
				</ul>
			</div>

			<div class="pageTit">
				<div class="conWrap">
					<h2>회원정보</h2>
				</div>
			</div>

			<div class="contents">
				<div class="conWrap">
					<h3 class="conTit">회원 정보 조회 및 수정</h3>
					<div class="tabStyle1">
						<table>
							<caption>보험료 견적</caption>
							<colgroup>
								<col width="200">
								<col width="*">
							</colgroup>
							<tbody>
								<tr>
									<th scope="row">
										<label for="id">ID</label>
									</th>
									<td colspan="3">
										<div class="inpTxt">
											<input type="text" v-model="state.userInfo.login_id" id="id" title="ID" disabled>
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="pwd">비밀번호</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input @click="openPopup('PopPwChange')" type="password" value="*********" id="pwd" placeholder="입력해 주세요" title="비밀번호">
										</div>
										<p class="inpInfo fcRed">비밀번호 변경을 원하는 경우, 입력창을 클릭하세요.</p>
									</td>
								</tr>
								<tr v-if="state.mstr_id_yn == 'Y'">
									<th scope="row">
										<label for="bizNum">사업자번호</label>
									</th>
									<td colspan="3">
										<div class="typeSplit5">
											<div class="inpTxt">
												<input type="text" v-model="state.userInfo.biz_no" id="bizNum" title="사업자번호" disabled>
											</div>
											<a @click="checkUser()" class="btnType sizeS colorB"><span>사업자공인인증</span></a>
										</div>
									</td>
								</tr>
								<tr v-if="state.mstr_id_yn != 'Y'">
									<th scope="row">
										<label for="bizNum">업무담당자 주민번호</label>
									</th>
									<td colspan="3">
										<form name="form1" method="post" ref="form1">
											<div class="typeSplit5">
												<div class="inpTxt typeReq">
													<input type="text" v-model="state.userInfo.txtJumin_bf"  maxlength="6" id="txtJumin_bf" title="업무담당자 주민번호">
												</div>
												<span style="margin: 13px 0px 0px 10px">-</span>
												<div class="inpTxt typeReq">
													<input type="password" v-model="state.userInfo.txtJumin_af" maxlength="7" name="txtJumin_af" id="txtJumin_af" npkencrypt="on" title="업무담당자 주민번호">
												</div>
												<a @click="checkUser()" class="btnType sizeS colorR"><span>개인공인인증</span></a>
											</div>
										</form>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="bizNum2">사업자별 식별번호</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input type="text"  maxlength="20" v-model="state.userInfo.biz_Idf_No" id="bizNum2" title="사업자별 식별번호">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="jobKo">직장한글명</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input type="text" maxlength="19"  v-model="state.userInfo.n_ctorkr" id="jobKo" title="직장한글명">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="jobEn">직장영문명</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input type="text"  maxlength="50" v-model="state.userInfo.n_ctoren" id="jobEn" title="직장영문명">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="phone">휴대폰번호</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input type="tel" style="width:32%;margin: 3px;" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" v-model="state.userInfo.tel_no1" maxlength="4"  id="phone1" title="휴대폰번호"/>-
											<input type="tel" style="width:32%;margin: 3px;" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" v-model="state.userInfo.tel_no2" maxlength="4"  id="phone2" title="휴대폰번호"/>-
											<input type="tel" style="width:32%" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" v-model="state.userInfo.tel_no3" maxlength="4"  id="phone3" title="휴대폰번호"/>
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="fax">FAX</label>
									</th>
									<td colspan="3">
										<div class="inpTxt typeReq">
											<input type="tel" style="width:32%;margin: 3px;" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" maxlength="4"   v-model="state.userInfo.fax_no1"  id="fax1" title="FAX"/>-
											<input type="tel" style="width:32%;margin: 3px;" v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" maxlength="4"  v-model="state.userInfo.fax_no2"  id="fax2" title="FAX"/>-
											<input type="tel" style="width:32%"  v-on:input="$event.target.value=$event.target.value.replace(/[^0-9]/g,'')" maxlength="4"   v-model="state.userInfo.fax_no3"  id="fax3" title="FAX"/>
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="bir">생년월일</label>
									</th>
									<td colspan="3">
										<div class="form_input_area type_calendar inpTxt typeReq" style="width:32%">
											<datepicker
												v-model="state.userInfo.birth_ymd"
												:locale="ko"
												class="form_input"
												inputFormat="yyyy-MM-dd"
												readonly
											/>
											<button type="button" class="btn_calendar">
												<span>날짜선택</span>
											</button>
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="division">부서</label>
									</th>
									<td>
										<div class="inpTxt typeReq">
											<input type="text" v-model="state.userInfo.dept_nm"  id="division" title="부서">
										</div>
									</td>
									<th scope="row">
										<label for="name">담당자명</label>
									</th>
									<td>
										<div class="inpTxt typeReq">
											<input maxlength="5" type="text" v-model="state.userInfo.charg_nm" id="name" title="담당자명">
										</div>
									</td>
								</tr>
								<tr>
									<th scope="row">
										<label for="code">담당자코드</label>
									</th>
									<td colspan="3">
										<div class="inpTxt">
											<input type="text" v-model="state.userInfo.gita" id="code" title="담당자코드" disabled>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div class="btnWrap">
						<a href="#" class="btnType sizeR colorBL"><span>확인</span></a>
						<a @click="openPopup('PopPwCheck')"  class="btnType sizeR colorB" ><span>수정</span></a>
					</div>
				</div>
			</div>
		</div>
		<PopPwChange ref="PopPwChangeRef" @close="handlePopupClose"></PopPwChange>
		<PopPwCheck ref="PopPwCheckRef" @closeCall="closeCall"></PopPwCheck>

</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import util from '@/common/util';
import { sessionUserInfo, load } from '@/common/sessionFactory';
import Header from '@/components/common/Header.vue';
import Footer from '@/components/common/Footer.vue';
import PopPwChange from '@/components/common/layerPop/PopPwChange.vue';
import PopPwCheck from '@/components/common/layerPop/PopPwCheck.vue';
import Datepicker from 'vue3-datepicker';
import { ko } from 'date-fns/locale';

const PopPwChangeRef = ref(null);
const PopPwCheckRef = ref(null);
const swalAlert = inject("swalAlert");
const axios = inject('axios');
const state = reactive({
	logid : '',
	bizNo : '',
	txtGita: '',
	userInfo : {},
	currDateFormat: util.formatDate(new Date(), "yyyy-mm-dd"),
	mstr_id_yn : '',
});

onMounted(async () => {	
	await load()

	await npPfsStartup(document.form2, true, true, false, false,"npkencrypt", "on");

	axios.json('/logHisLdg.do', {memo:"회원조회수정" ,page:window.location.hash});
	console.log(sessionUserInfo)
	if(!_.isEmpty(sessionUserInfo)){
		state.userInfo = rmSpaceObject(sessionUserInfo.userInfo);
		state.userInfo.birth_ymd = new Date(state.userInfo.birth_ymd);
		state.mstr_id_yn = sessionUserInfo.userInfo.mstr_id_yn;
	}

	setTimeout(()=>{
		$('.nppfs-elements').hide();
	},'1000')

})

const checkUser = () =>{
	axios.json('/genKsbizNonce.do', {}).then(function(result){
	if(result.errorCode != "undefined"){
		KeySharpBiz.sign("ksbizNonce="+result.data.KSBIZ_NONCE, complete_sign, {addNonce:false})	
	}else{
		console.log(result.errorCode);
	}
	})
}

const closeCall = () => {
	memberUpd();
}


const complete_sign = (result) => {
	const param = {};
	param.ksbizSig = result.data;
	param.idn = state.mstr_id_yn == 'Y'? state.corpNo : state.userInfo.txtJumin_bf;//state.userInfo.biz_no
	param.ksbizVidRandom = result.vidRandom;
	param.sType = state.mstr_id_yn == 'Y'? '1' : '2';

	param.e2eRes = $('[name=__E2E_RESULT__]').val();
	param.e2eUni = $('[name=__E2E_UNIQUE__]').val();
	param.e2e = $('[name=txtJumin_af__E2E__]').val();
	param.e2epln = $('[name=txtJumin_af]').val();

	axios.json('/ofapvAthdcElcSgnVrfReg.do', param).then(function(result){
		console.log(result)
		if(result.data.errorCode1 == 0 && result.data.errorCode2 == 0){
			swalAlert("공인인증 등록성공하였습니다.")
			state.athdc_mbdy_enc = result.data.subjectDN; //공인인증 유효키
			state.athdc_efct_dt = result.data.dateafter; //공인인증 만료일자
			
			// isVisible.value =false;
			// emits('success');
					
		}else if(result.data.errorCode1 == 0 && result.data.errorCode2 != 0){
			swalAlert(result.data.msg)
			close();
		}else{
			swalAlert("공인인증 등록확인 실패하였습니다.(전자서명 검증에 실패하였습니다.)")
			close();
		}	
	})
	console.log("Call BACK")
}

const openPopup = (name) => {
  if ("PopPwChange" == name) {
    PopPwChangeRef.value.open({
		login_id  : state.userInfo.login_id,
		biz_no	  : state.userInfo.biz_no,
		birth_ymd : state.userInfo.birth_ymd,
		tel_no2 : state.userInfo.tel_no2,
		tel_no3 : state.userInfo.tel_no3
    });
  } else if("PopPwCheck" == name){
    PopPwCheckRef.value.open({
		login_id  : state.userInfo.login_id,
		biz_no	  : state.userInfo.biz_no,
		birth_ymd : state.userInfo.birth_ymd,
    });
  }
};

const memberUpd = () => {

	if(_.isEmpty(state.userInfo.corp_no)){
		return swalAlert("사업자별 식별번호를 입력해주세요.")
	}else if(_.isEmpty(state.userInfo.n_ctorkr)){
		return swalAlert("직장한글명을 입력해주세요.")
	}else if(_.isEmpty(state.userInfo.n_ctoren)){
		return swalAlert("직장영문명을 입력해주세요.")
	}else if(_.isEmpty(state.userInfo.tel_no1) ||_.isEmpty(state.userInfo.tel_no2) || _.isEmpty(state.userInfo.tel_no3)){
		return swalAlert("휴대폰번호를 입력해주세요.")
	}else if(_.isEmpty(state.userInfo.fax_no1) || _.isEmpty(state.userInfo.fax_no2) || _.isEmpty(state.userInfo.fax_no3)){
		return swalAlert("FAX를 입력해주세요.")
	}else if(_.isEmpty(util.formatDate(state.userInfo.birth_ymd, 'yyyy-mm-dd'))){
		return swalAlert("생년월일을 입력해주세요.")
	}else if(_.isEmpty(state.userInfo.dept_nm)){
		return swalAlert("부서명을 입력해주세요.")
	}else if(_.isEmpty(state.userInfo.charg_nm)){
		return swalAlert("담당자명을 입력해주세요.")
	}


	let param = {};
	param.login_id = state.userInfo.login_id
	param.n_ctorkr = state.userInfo.n_ctorkr
	param.n_ctoren = _.toUpper(state.userInfo.n_ctoren)
	param.biz_no   = state.userInfo.biz_no
	param.biz_idf_no  = state.userInfo.biz_Idf_No
	param.tel_no1 =	state.userInfo.tel_no1
	param.tel_no2 =	state.userInfo.tel_no2
	param.tel_no3 =	state.userInfo.tel_no3
	param.fax_no1 =	state.userInfo.fax_no1
	param.fax_no2 =	state.userInfo.fax_no2
	param.fax_no3 =	state.userInfo.fax_no3
	param.birth_ymd = util.formatDate(state.userInfo.birth_ymd, 'yyyy-mm-dd');
	param.dept_nm =	state.userInfo.dept_nm
	param.charg_nm = state.userInfo.charg_nm
	param.mstr_id_yn = state.userInfo.mstr_id_yn
	param.athdc_mbdy_enc = state.athdc_mbdy_enc //공인인증 유효키
	param.athdc_efct_dt = state.athdc_efct_dt //공인인증 만료일자

	axios.json('/uptmbrRegi.do', param).then(function(result){
		return swalAlert(result.data.msg)
	})

}
function rmSpaceObject(obj){
	return _.mapValues(obj, value => _.isString(value) ? _.trim(value) : value);
}



</script>

